






























































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import CareerHeadline from '@/components/core/CareerHeadline.vue';

@Component({
  components: {
    CareerHeadline
  }
})
export default class Careers extends Vue {
}
